import { render, staticRenderFns } from "./RecipeProcedure.vue?vue&type=template&id=26545e62&"
import script from "./RecipeProcedure.vue?vue&type=script&lang=ts&"
export * from "./RecipeProcedure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports